import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";

/** Active section navigation stays available while its page updates or loads. */
export default function XavierNavGroup({ item, Icon, pathname }) {
  const [expanded, setExpanded] = useState(false);
  const target = `/${item.page}`;
  const active = pathname === target || pathname.startsWith(`${target}/`);
  const open = active || expanded;
  const submenuId = `xv-nav-submenu-${item.page.replace(/[^a-zA-Z0-9-]/g, "-")}`;
  return <div className={`xv-nav-group ${open ? "is-open" : ""}`}>
    <button type="button" className={`xv-nav-item ${active ? "is-active" : ""}`}
      aria-expanded={open} aria-controls={submenuId}
      onClick={() => { if (!active) setExpanded(value => !value); }}>
      <Icon aria-hidden="true" strokeWidth={1.7} />
      <span>{item.title}</span><FiChevronDown className="xv-nav-group__chevron" aria-hidden="true" />
    </button>
    <div id={submenuId} className="xv-nav-submenu" aria-label={item.title} hidden={!open}>
      {item.submenu.map(child => {
        const childTarget = `/${child.page}`;
        const childActive = pathname.replace(/\/$/, "") === childTarget;
        return <Link key={child.page} to={childTarget}
          className={`xv-nav-item xv-nav-submenu__item ${childActive ? "is-active" : ""}`}
          aria-current={childActive ? "page" : undefined}>{child.title}</Link>;
      })}
    </div>
  </div>;
}
